<template>
  <div class="main">
    接口健康状况
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="name" label="接口名" width="180"> </el-table-column>
      <el-table-column prop="version" label="版本号" width="180"> </el-table-column>
      <el-table-column prop="status" label="状态"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
    }
  },
  mounted() {
    tokenUrlinfo().then(res => {
      let version = res.app.version
      let name = res.app.name
      tokenUrlHealth()
        .then(res => {
          let status = res.status
          this.tableData.push({
            name: name,
            version: version,
            status: status,
          })
        })
        .catch(() => {
          this.tableData.push({
            name: '/iam',
            version: '未知',
            status: '服务暂不可用',
          })
        })
    })
    baseUrlinfo()
      .then(res => {
        let version = res.app.version
        let name = res.app.name
        baseUrlHealth().then(res => {
          let status = res.status
          this.tableData.push({
            name: name,
            version: version,
            status: status,
          })
        })
      })
      .catch(() => {
        this.tableData.push({
          name: '/api/iam-manage/v1.0',
          version: '未知',
          status: '服务暂不可用',
        })
      })
    deviceUrlinfo()
      .then(res => {
        let version = res.app.version
        let name = res.app.name
        deviceUrlHealth().then(res => {
          let status = res.status
          this.tableData.push({
            name: name,
            version: version,
            status: status,
          })
        })
      })
      .catch(() => {
        this.tableData.push({
          name: '/api/device-manage/v1.0',
          version: '未知',
          status: '服务暂不可用',
        })
      })
    metricUrlinfo()
      .then(res => {
        let version = res.app.version
        let name = res.app.name
        metricUrlHealth().then(res => {
          let status = res.status
          this.tableData.push({
            name: name,
            version: version,
            status: status,
          })
        })
      })
      .catch(() => {
        this.tableData.push({
          name: '/api/device-metric/v1.0',
          version: '未知',
          status: '服务暂不可用',
        })
      })
    cautionUrlinfo()
      .then(res => {
        if (res.value) {
          let version = res.app.version
          let name = res.app.name
          cautionUrlHealth().then(res => {
            let status = res.status
            this.tableData.push({
              name: name,
              version: version,
              status: status,
            })
          })
        } else {
          this.tableData.push({
            name: 'alert/v1.0',
            version: '暂无版本信息',
            status: '返回为空',
          })
        }
      })
      .catch(() => {
        this.tableData.push({
          name: '/api/alert/v1.0',
          version: '未知',
          status: '服务暂不可用',
        })
      })
    apiUrlinfo()
      .then(res => {
        if (res.value) {
          let version = res.app.version
          let name = res.app.name
          apiUrlHealth().then(res => {
            let status = res.status
            this.tableData.push({
              name: name,
              version: version,
              status: status,
            })
          })
        } else {
          this.tableData.push({
            name: 'apigateway',
            version: '暂无版本信息',
            status: '返回为空',
          })
        }
      })
      .catch(() => {
        this.tableData.push({
          name: '/apigateway',
          version: '未知',
          status: '服务暂不可用',
        })
      })
  },
}
import {
  tokenUrlinfo,
  tokenUrlHealth,
  cautionUrlHealth,
  cautionUrlinfo,
  baseUrlHealth,
  baseUrlinfo,
  deviceUrlHealth,
  deviceUrlinfo,
  metricUrlinfo,
  metricUrlHealth,
  apiUrlinfo,
  apiUrlHealth,
} from '@/api/version'
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.main
  padding 20px 50px
  .el-table
    margin-top 20px
</style>
